module.exports = __webpack_public_path__ + "img/image6.37d76a81.png";